module.exports = __webpack_public_path__ + "desktop-phone-format-1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/desktop-phone-format-1.webm
// module id = 1160
// module chunks = 10